export default __webpack_public_path__ + "static/share-18d1aa38227ec17b378cef9533bc9087.png";